module.exports = __webpack_public_path__ + "static/Sushant_Kumar_headshot_lores-603692e6c26c1ffd9c6cb74719a21d92.png";